// Module
var code = "<div class=\"grid_division\"> <div class=\"main_grid\"> <div> <div class=\"mishion_history\"> <div class=\"mission_title\">MEAL Logs</div> </div> <meallog-main-grid> </meallog-main-grid> </div> </div> </div> ";
// Exports
var _module_exports = code;;
var path = 'machines/common/Pages/MealLog/main/index.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;